import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import CameraAccessDenied from '../../../components/camera-access-denied';
import CameraAccessRequest from '../../../components/camera-access-request';
import CameraError from '../../../components/camera-error';
import { useNonIdDocMachine } from '../../context/non-id-doc-context';
import DesktopProcessing from '../desktop-processing';
import DesktopRetry from '../desktop-retry';
import DocumentPrompt from '../document-prompt';
import Init from '../init';
import MobileImageCapture from '../mobile-image-capture';
import MobileProcessing from '../mobile-processing';
import MobileRetry from '../mobile-retry';
type RouterProps = {
  onDone: () => void;
};
const Router = t0 => {
  const $ = _c(23);
  const {
    onDone
  } = t0;
  const [state, dispatch] = useNonIdDocMachine();
  const isDone = state.value === "complete" || state.value === "failure";
  let t1;
  let t2;
  if ($[0] !== isDone || $[1] !== onDone) {
    t1 = () => {
      if (isDone) {
        onDone();
      }
    };
    t2 = [isDone, onDone];
    $[0] = isDone;
    $[1] = onDone;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  if (state.value === "init") {
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <Init />;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    return t3;
  }
  if (state.value === "documentPrompt") {
    let t3;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <DocumentPrompt />;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    return t3;
  }
  if (state.value === "mobileRequestCameraAccess") {
    let t3;
    if ($[6] !== dispatch) {
      t3 = <CameraAccessRequest onClose={() => dispatch({
        type: "navigatedToPrev"
      })} onCameraAccessDenied={() => dispatch({
        type: "cameraAccessDenied",
        payload: {
          status: "denied"
        }
      })} onCameraError={cause => dispatch({
        type: "cameraErrored",
        payload: {
          cause
        }
      })} onSuccess={() => dispatch({
        type: "cameraAccessGranted",
        payload: {
          status: "granted"
        }
      })} />;
      $[6] = dispatch;
      $[7] = t3;
    } else {
      t3 = $[7];
    }
    return t3;
  }
  if (state.value === "mobileCameraAccessDenied") {
    let t3;
    if ($[8] !== dispatch) {
      t3 = () => dispatch({
        type: "navigatedToPrev"
      });
      $[8] = dispatch;
      $[9] = t3;
    } else {
      t3 = $[9];
    }
    let t4;
    if ($[10] !== state.context.device || $[11] !== t3) {
      t4 = <CameraAccessDenied device={state.context.device} onClose={t3} />;
      $[10] = state.context.device;
      $[11] = t3;
      $[12] = t4;
    } else {
      t4 = $[12];
    }
    return t4;
  }
  if (state.value === "mobileCameraErrored") {
    let t3;
    if ($[13] !== dispatch) {
      t3 = () => dispatch({
        type: "navigatedToPrev"
      });
      $[13] = dispatch;
      $[14] = t3;
    } else {
      t3 = $[14];
    }
    const t4 = state.context.cameraErrorCause ?? "other-error";
    let t5;
    if ($[15] !== t3 || $[16] !== t4) {
      t5 = <CameraError onBack={t3} cause={t4} />;
      $[15] = t3;
      $[16] = t4;
      $[17] = t5;
    } else {
      t5 = $[17];
    }
    return t5;
  }
  if (state.value === "mobileImageCapture") {
    let t3;
    if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <MobileImageCapture />;
      $[18] = t3;
    } else {
      t3 = $[18];
    }
    return t3;
  }
  if (state.value === "mobileRetry") {
    let t3;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <MobileRetry />;
      $[19] = t3;
    } else {
      t3 = $[19];
    }
    return t3;
  }
  if (state.value === "desktopRetry") {
    let t3;
    if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <DesktopRetry />;
      $[20] = t3;
    } else {
      t3 = $[20];
    }
    return t3;
  }
  if (state.value === "mobileProcessing") {
    let t3;
    if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <MobileProcessing />;
      $[21] = t3;
    } else {
      t3 = $[21];
    }
    return t3;
  }
  if (state.value === "desktopProcessing") {
    let t3;
    if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <DesktopProcessing />;
      $[22] = t3;
    } else {
      t3 = $[22];
    }
    return t3;
  }
  return null;
};
export default Router;